import {
  REQUEST_VEHICLE_POSITION,
  RECEIVE_VEHICLE_POSITION,
  SET_VEHICLE_POSITION_TIMEOUT,
  UNSET_VEHICLE_POSITION_TIMEOUT,
} from 'ondemand/actions/vehiclePosition';

export default function vehiclePosition(
  state = {
    agencyId: null,
    isFetching: false,
    item: null,
    timeout: null,
    vehicleId: null,
  },
  action,
) {
  switch (action.type) {
    case REQUEST_VEHICLE_POSITION:
      return Object.assign({}, state, {isFetching: true});
    case RECEIVE_VEHICLE_POSITION:
      return Object.assign({}, state, {
        agencyId: action.agencyId,
        isFetching: false,
        item: action.vehiclePosition,
        vehicleId: action.vehicleId,
      });
    case SET_VEHICLE_POSITION_TIMEOUT:
      return Object.assign({}, state, {timeout: action.timeout});
    case UNSET_VEHICLE_POSITION_TIMEOUT:
      return Object.assign({}, state, {timeout: null});
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/ondemand/reducers/vehiclePosition.js